import * as d3 from "d3";
export { InterviewProgress, EarningGraph };

class InterviewProgress {
	progressGraph(id, id2, data, currentFilter, imagePath1, imagePath2) {
		console.log("the data is ", data);
		if (
			document.getElementById(id2) &&
			document.getElementById(id2).innerHTML != ""
		) {
			document.getElementById(id2).innerHTML = "";
		}

		console.log("the innerHeight", window.innerHeight);
		console.log("the innerWidth", window.innerWidth);
		const margin = { top: 20, right: 30, bottom: 30, left: 60 };
		let width = window.innerWidth - margin.left - margin.right - 230;
		let height = 280 - margin.top - margin.bottom;
		if (data.length > 16) {
			console.log("change 6");
			width = window.innerWidth - margin.left - margin.right + 1200;
		}
		if (data.length > 30) {
			console.log("change 7");
			width = window.innerWidth - margin.left - margin.right + 1500;
		}
		if (window.innerWidth < 1750) {
			width = window.innerWidth - margin.left - margin.right - 190;
		}
		if (window.innerWidth < 1200 && data.length > 12) {
			console.log("change 5");
			width = window.innerWidth - margin.left - margin.right + 800;
		}
		if (window.innerWidth < 1550 && data.length > 12) {
			console.log("change 4");
			width = window.innerWidth - margin.left - margin.right + 600;
			// height = 550 - margin.top - margin.bottom;
		}
		if (window.innerHeight < 650) {
			console.log("change 3");
			height = 250 - margin.top - margin.bottom;
		}
		if (window.innerWidth < 1024 && data.length <= 12) {
			width = window.innerWidth - margin.left - margin.right + 800;
		}
		if (window.innerWidth < 450 && data.length > 12) {
			console.log("change 2");
			width = window.innerWidth - margin.left - margin.right + 1800;
		} else if (window.innerWidth < 450 && data.length <= 12) {
			console.log("change 1");
			width = window.innerWidth - margin.left - margin.right + 800;
			height = 250 - margin.top - margin.bottom;
		}
		console.log("the width is ", window.innerWidth);
		const tooltip = d3
			.select("body")
			.append("div")
			.attr("class", "tooltip")
			.style("position", "absolute")
			.style("opacity", 0)
			.style("background", "white")
			.style("border", "1px solid rgba(136, 136, 136, 1)")
			.style("border-radius", "8px")
			.style("padding", "10px")
			.style("pointer-events", "none")
			.style("font-size", "14px");

		function showTooltip(event, d, isOverlap, average) {
			tooltip.style("opacity", 1);

			let dateLabel = "";
			if (d.date && d.month) {
				dateLabel = `${d.date} ${d.month}`;
			} else if (d.month && d.year) {
				dateLabel = `${d.month} ${d.year}`;
			} else if (d.year) {
				dateLabel = `${d.year}`;
			} else if (d.month) {
				dateLabel = `${d.month}`;
			} else if (d.date) {
				dateLabel = `${d.date}`;
			}

			let content = isOverlap
				? `<strong>${dateLabel}</strong><br>
				   <img src="${imagePath2}"/> Average Interviews Taken: ${d.averageInterviews} <br>
				   <img src="${imagePath1}"/> Your Interviews Taken: ${d.interviews}`
				: average
				? `<strong>${dateLabel}</strong><br>
				   <img src="${imagePath2}"/> Average Interviews Taken: ${d.averageInterviews}`
				: `<strong>${dateLabel}</strong><br>
				   <img src="${imagePath1}"/> Your Interviews Taken: ${d.interviews}`;

			tooltip.html(content);

			let tooltipBounds = tooltip.node().getBoundingClientRect();
			let parentBounds = document.getElementById(id2).getBoundingClientRect();

			let mouseX = event.pageX;
			let mouseY = event.pageY;

			// Set initial tooltip position with slight offset
			let tooltipX = mouseX + 3;
			let tooltipY = mouseY + 3;

			// Ensure tooltip stays within parent bounds
			if (tooltipX + tooltipBounds.width > parentBounds.right) {
				tooltipX = parentBounds.right - tooltipBounds.width - 10;
			}

			if (tooltipX < parentBounds.left) {
				tooltipX = parentBounds.left + 10;
			}

			if (tooltipY + tooltipBounds.height > parentBounds.bottom) {
				tooltipY = parentBounds.bottom - tooltipBounds.height - 10;
			}

			if (tooltipY < parentBounds.top) {
				tooltipY = parentBounds.top + 10;
			}

			tooltip.style("left", `${tooltipX}px`).style("top", `${tooltipY}px`);

			if (window.innerWidth < 768) {
				setTimeout(() => {
					hideTooltip();
				}, 2000);
			}
		}

		// Function to hide tooltip
		function hideTooltip() {
			tooltip.style("opacity", 0);
		}

		const svg = d3
			.select("#" + id2)
			.append("svg")
			.attr("width", width + margin.left + margin.right)
			.attr(
				"viewBox",
				`0 0 ${width + margin.left + margin.right} ${
					height + margin.top + margin.bottom + 20
				}`
			);

		const g = svg
			.append("g")
			.attr("transform", `translate(${margin.left},${margin.top})`);

		const getDomainValue = (d) => {
			if (currentFilter === "date") {
				return `${d.date}-${d.month}`;
			} else if (currentFilter === "month") {
				return `${d.month}-${d.year}`;
			} else {
				return d[currentFilter];
			}
		};

		// X scale
		const spacing = 40;
		const x = d3
			.scalePoint()
			.domain(data.map(getDomainValue))
			.range([spacing, width - spacing]);

		// max value
		const maxDataValue = d3.max(data, (d) =>
			Math.max(d.interviews, d.averageInterviews)
		);

		const minTicks = 4;
		// let stepSize = Math.ceil(maxDataValue / minTicks);
		let stepSize;
		if (maxDataValue <= 1) {
			stepSize = 0.25;
		} else if (maxDataValue <= 2) {
			stepSize = 0.5;
		} else {
			stepSize = Math.ceil(maxDataValue / minTicks);
		}
		const maxY = Math.ceil(maxDataValue / stepSize) * stepSize;
		// Y scale
		const y = d3.scaleLinear().domain([0, maxY]).range([height, 0]).nice();

		// custom tick value
		const yTicks = d3.range(0, maxY + stepSize, stepSize);

		//to create grid
		g.append("g")
			.attr("class", "grid")
			.call(
				d3
					.axisLeft(y)
					.tickSize(-width - 40)
					.tickFormat("")
					.tickValues(yTicks)
			)
			.selectAll(".tick line")
			.attr("opacity", 0.2)
			.attr("class", "grid-line");

		//to add y-axis label
		g.append("g")
			.attr("class", "axis")
			.call(
				d3
					.axisLeft(y)
					.tickValues(yTicks)
					.tickFormat((d) => (Number.isInteger(d) ? d3.format("d")(d) : ""))
			)
			.attr("transform", "translate(-10,0)");

		// Put the vertical label on the graph in Y-axis
		g.append("text")
			.attr("transform", "rotate(-90)")
			.attr("x", -height / 2)
			.attr("y", -spacing - 5)
			.style("font-size", "14px")
			.style("fill", "rgba(136, 136, 136, 0.8)")
			.style("text-anchor", "middle")
			.text("No. of Interviews");

		// Line generator for 'panelist interview taken'
		const line1 = d3
			.line()
			.x((d) => x(getDomainValue(d)))
			.y((d) => y(d.interviews));

		// Line generator for 'overall interview taken'
		const line2 = d3
			.line()
			.x((d) => x(getDomainValue(d)))
			.y((d) => y(d.averageInterviews));

		// Add lines for 'panelist interview taken'
		g.append("path")
			.data([data])
			.attr("class", "line")
			.attr("stroke", "rgba(74, 58, 255, 1)")
			.attr("stroke-width", 3)
			.attr("fill", "none")
			.attr("d", line1);

		// Add lines for 'overall interview taken'
		g.append("path")
			.data([data])
			.attr("fill", "none")
			.attr("class", "line")
			.attr("stroke", "rgba(200, 147, 253, 1)")
			.attr("stroke-width", 3)
			.attr("d", line2);

		g.selectAll(".dot1")
			.data(data)
			.enter()
			.append("circle")
			.attr("class", "dot")
			.attr("cx", (d) => x(getDomainValue(d)))
			.attr("cy", (d) => y(d.interviews))
			.attr("r", 8)
			.attr("fill", "white")
			.attr("stroke", "rgba(74, 58, 255, 1)")
			.on("mouseover", function (event, d) {
				const isOverlap = y(d.interviews) == y(d.averageInterviews);
				showTooltip(event, d, isOverlap);
			})
			.on("mouseout", hideTooltip);

		// Add dots for 'overall interview taken'
		g.selectAll(".dot2")
			.data(data)
			.enter()
			.append("circle")
			.attr("class", "dot")
			.attr("cx", (d) => x(getDomainValue(d)))
			.attr("cy", (d) => y(d.averageInterviews))
			.attr("r", 8)
			.attr("fill", "white")
			.attr("stroke", "rgba(200, 147, 253, 1)")
			.on("mouseover", function (event, d) {
				const isOverlap = y(d.interviews) == y(d.averageInterviews);
				showTooltip(event, d, isOverlap, true);
			})
			.on("mouseout", hideTooltip);

		// Adding x-axis label with updated tickFormat
		g.append("g")
			.attr("class", "axis")
			.attr("transform", `translate(0,${height + 10})`)
			.call(
				d3.axisBottom(x).tickFormat((d, i) => {
					// Find the corresponding data item
					const item = data.find((item) => getDomainValue(item) === d);
					if (!item) return d;

					if (currentFilter === "year") {
						return item.year;
					} else if (currentFilter === "date" && item.date) {
						return item.date + " " + item.month;
					} else if (currentFilter === "month") {
						return item.month + (item.year ? " " + item.year : "");
					} else {
						// Default fallback
						return d;
					}
				})
			);

		//style for tick
		g.selectAll(".tick text")
			.style("font-size", "14px")
			.style("color", "rgba(97, 94, 131, 1)")
			.style("font-family", "Lato");

		// removes the path of the axis
		g.selectAll(".axis path, .axis line").style("stroke", "none");

		//removes the path of the domain
		g.selectAll("path.domain").style("stroke", "none");
	}
}

class EarningGraph {
	async heatmappanel(
		datass,
		colNum,
		myCellSize,
		myCellHeight,
		margin,
		widthVal,
		showHeading,
		monthGap,
		perRowCell,
		cellGap,
		x_axis_cellGap,
		y_axis_cellGap,
		isLaptop
	) {
		const data = datass;
		const width = widthVal - margin.left - margin.right;
		const cellSize = myCellSize;
		const height = myCellHeight * 25 - margin.top - margin.bottom;

		// Remove any existing tooltip before creating a new one
		d3.selectAll(".tooltipHeatmap").remove();

		const svg = d3
			.select("#heatmap2")
			.append("svg")
			.attr("height", "100%")
			.attr("width", "100%")
			.attr(
				"viewBox",
				`0 0 ${width + margin.left + margin.right} ${
					height + margin.top + margin.bottom
				}`
			)
			.attr("preserveAspectRatio", "xMidYMid meet")
			.append("g")
			.attr(
				"transform",
				"translate(" + margin.left / 3 + "," + margin.top + ")"
			);

		let largest = Math.max(...data.map((o) => o.count));

		const color = d3
			.scaleQuantize()
			.domain([0, largest])
			.range(["#A6CBC5", "#68B4A9", "#44A798", "#289D8B"]);

		const getUniqueMonths = (data) => {
			const uniqueMonths = [];
			data.forEach((d) => {
				const monthYear = `${d.year}-${d.month}`;
				if (!uniqueMonths.includes(monthYear)) {
					uniqueMonths.push(monthYear);
				}
			});
			return uniqueMonths;
		};

		const uniqueMonths = getUniqueMonths(data).slice(0, perRowCell);
		const monthGroup = svg
			.selectAll(".month")
			.data(uniqueMonths)
			.enter()
			.append("g")
			.attr("class", "month")
			.attr("transform", (d, i) => {
				const xOffset =
					i < 3
						? (i % colNum) * (cellSize * perRowCell + cellGap * 5 + monthGap)
						: (i % 3) * (cellSize * perRowCell + cellGap * 5 + monthGap);
				const yOffset =
					i < 3
						? Math.floor(i / colNum) *
						  (cellSize * perRowCell + cellGap * 5 + 50)
						: Math.floor(i / 3) * (cellSize * perRowCell + cellGap * 5 + 15);
				return "translate(" + xOffset + "," + yOffset + ")";
			});
		const constDivNumX =
			uniqueMonths.length == 2 ? 2 : uniqueMonths.length > 3 ? 1.5 : 2;
		const constDivNumY =
			uniqueMonths.length == 3 || uniqueMonths.length == 1 ? 3 : 2;
		if (showHeading) {
			const mobOffset = isLaptop ? 0 : 15;
			monthGroup
				.append("text")
				.attr("class", "month-label")
				.attr(
					"x",
					(cellSize * perRowCell + cellGap * 5) / constDivNumX -
						margin.left -
						margin.right -
						colNum * 2 +
						mobOffset
				)
				.attr("y", -margin.top / constDivNumY)
				.text((d) => {
					const [year, month] = d.split("-");
					return d3.timeFormat("%b, %Y")(new Date(year, month - 1, 1));
				})
				.style("color", "#3A3C40")
				.style("font-size", "4px")
				.style("font-weight", "500")
				.style("font-family", "Montserrat");
		}

		let Tooltip = d3
			.select("body")
			.append("div")
			.style("opacity", 0)
			.attr("class", "tooltipHeatmap")
			.style("width", "auto")
			.style("height", "auto")
			.style("padding", "8.01px 12.01px")
			.style("border-radius", "8px")
			.style("background-color", "#D9D9D9")
			.style("position", "absolute")
			.style("text-align", "center")
			.style("font-family", "Montserrat")
			.style("font-size", "12px")
			.style("font-weight", "400")
			.style("line-height", "12.19px")
			.style("color", "#696969")
			.style("pointer-events", "none");

		let touchTimer;
		const handleTooltip = function (event, d) {
			const formatDate1 = d3.timeFormat("%b %d");
			const dateStr = d3.timeFormat("%Y-%m-%d")(d);
			const datum = data.find(
				(e) =>
					`${e.year}-${("0" + e.month).slice(-2)}-${("0" + e.day).slice(
						-2
					)}` === dateStr
			);
			const tooltipText =
				datum && datum.count > 1
					? `${datum.count} Earned on ${formatDate1(d)}`
					: datum && datum.count == 1
					? `${datum.count} Earned on ${formatDate1(d)}`
					: `No Earning on ${formatDate1(d)}`;

			const touch = event.type.startsWith("touch") ? event.touches[0] : event;

			Tooltip.style("opacity", 1)
				.style("visibility", "visible")
				.style("left", touch.pageX - 25 + "px")
				.style("top", touch.pageY - 35 + "px");
			Tooltip.html(`<strong>${tooltipText}</strong>`);

			if (touchTimer) clearTimeout(touchTimer);

			touchTimer = setTimeout(() => {
				Tooltip.style("opacity", 0).style("visibility", "hidden");
			}, 1000);
		};

		monthGroup.each(function (monthYear) {
			const [year, month] = monthYear.split("-").map(Number);
			const monthDays = d3.timeDays(
				new Date(year, month - 1, 1),
				new Date(year, month, 1)
			);

			d3.select(this)
				.selectAll(".day")
				.data(monthDays)
				.enter()
				.append("rect")
				.attr("class", "day")
				.attr("width", cellSize + 1)
				.attr("height", cellSize)
				.attr("x", (d, i) => (i % perRowCell) * (cellSize + x_axis_cellGap))
				.attr(
					"y",
					(d, i) => Math.floor(i / perRowCell) * (cellSize + y_axis_cellGap)
				)
				.attr("rx", 1)
				.attr("ry", 1)
				.attr("fill", (d) => {
					const dateStr = d3.timeFormat("%Y-%m-%d")(d);
					const datum = data.find(
						(e) =>
							`${e.year}-${("0" + e.month).slice(-2)}-${("0" + e.day).slice(
								-2
							)}` === dateStr
					);
					return datum.count > 0 ? color(datum.count) : "#F5F5F5";
				})
				.on("mousemove", handleTooltip)
				.on("mouseout", () => {
					Tooltip.style("opacity", 0).style("visibility", "hidden");
				})
				.on("touchstart", handleTooltip)
				.on("touchend", handleTooltip);
		});
	}
}
